import * as ng from 'angular';
import * as uir from '@uirouter/angularjs';
import { AnonShellController } from './anon-shell.component';

export class LoginController {
   static $inject = ['$state', 'session', 'toast'];

   constructor(
      private $state:uir.StateService,
      private session,
      private toast
   ) { }

   loggingIn = false;
   username:string;
   password:string;

   login() {
      this.loggingIn = true;
      this.session.login(this.username, this.password).then(() => {
         this.$state.go('dashboard');
      }).catch(response => {
         let title = 'Invalid Credentials';
         let message = 'Your username or password is incorrect';

         if (response.data.error == 'org_locked') {
            title = 'Organization Locked';
            message = 'Your organization is locked. Please contact your account representative.';
         }

         if (response.data.error == 'trial_expired') {
            title = 'Account';
            message = 'The trial period for this account has expired. Please contact your account representative.';
         }

         if (response.data.error == 'locked') {
            title = 'Account';
            message = 'Your account is locked. Please contact your account representative.';
         }

         if (response.data.error == 'password_expired') {
            title = 'Account';
            message = 'Your password has expired. Please reset your password to continue accessing your account.';
         }

         this.toast.title(title)
            .message(message)
            .error()
            .send();
      }).finally(() => this.loggingIn = false);
   }
}

ng.module('e360').component('login', {
   controller: LoginController,
   templateUrl: require('./login.html')
});
